import { passosLinhaTempo } from '../../../mocks/worksheet-linha-tempo';

export default function PassosTimeline() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Os 8 Passos da Técnica
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Siga este protocolo para liberar emoções negativas e criar um futuro motivador
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {passosLinhaTempo.map((passo) => (
            <div
              key={passo.numero}
              className="bg-white border-2 border-gray-100 rounded-2xl p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${passo.cor} rounded-2xl flex items-center justify-center mb-4 shadow-lg`}>
                <i className={`${passo.icone} text-white text-3xl`}></i>
              </div>
              
              <div className="flex items-center gap-3 mb-3">
                <span className={`text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r ${passo.cor}`}>
                  {passo.numero}
                </span>
                <h3 className="font-bold text-gray-900 text-lg leading-tight">
                  {passo.titulo}
                </h3>
              </div>
              
              <p className="text-sm text-gray-600 leading-relaxed">
                {passo.descricao}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-violet-50 to-fuchsia-50 border-l-4 border-violet-600 p-6 rounded-r-2xl">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 bg-violet-600 rounded-xl flex items-center justify-center flex-shrink-0">
              <i className="ri-lightbulb-flash-line text-white text-xl"></i>
            </div>
            <div>
              <h4 className="font-bold text-gray-900 mb-2">Dica Importante</h4>
              <p className="text-gray-700 leading-relaxed">
                A chave da Timeline Therapy é trabalhar sempre <strong>dissociado</strong> — vendo a cena de fora, 
                como se assistisse a um filme. Isso permite liberar a emoção sem reviver o trauma. 
                Se em algum momento você se sentir muito conectado emocionalmente, flutue mais alto acima da linha do tempo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
